<template>
    <el-dialog v-model="dialogVisible" width="86%" top="30px" :show-close="false">
        <div class="header">
            <div class="title">历史委托</div>
            <div class="h-button">
                <el-button @click="load()" :loading="loading">刷新</el-button>
                <el-button @click="loadMore()" :loading="loadingMore" class="mr15">下一页 {{ page }}</el-button>
                <el-tag size="large" :type="totalpnl >= 0 ? 'success' : 'danger'" class="mr15">
                    实现盈亏 {{ Math.round((totalpnl) * 100) / 100 }}
                </el-tag>
                <el-tag size="large" type="danger" class="mr15">
                    手续费 {{ Math.round((totalfee) * 100) / 100 }}
                </el-tag>
                <el-tag size="large" :type="total >= 0 ? 'success' : 'danger'">
                    合计 {{ Math.round((total) * 100) / 100 }}
                </el-tag>
            </div>
        </div>
        <div class="history-body">
            <el-table :data="list">
                <el-table-column type="index" width="80" align="center"></el-table-column>
                <el-table-column label="交易对" align="center" width="120">
                    <template #default="{ row }">
                        {{ row.instId.replace("-SWAP", "").replace("-", "") }}
                    </template>
                </el-table-column>
                <el-table-column label="仓位模式" align="center" width="120">
                    <template #default="{ row }">
                        <el-tag v-show="row.tdMode === constants.CROSS"
                            :type="row.posSide === constants.SHORT ? 'danger' : 'success'"
                            style="width:80px; text-align:center">全仓 ×
                            {{ parseInt(row.lever) }}</el-tag>
                        <el-tag v-show="row.tdMode !== constants.CROSS"
                            :type="row.posSide === constants.SHORT ? 'danger' : 'success'"
                            style="width:80px; text-align:center">逐仓 ×
                            {{ parseInt(row.lever) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="方向" align="center" width="80">
                    <template #default="{ row }">
                        <span class="red" v-if="row.side == 'sell'">平多</span>
                        <span class="green" v-if="row.side == 'buy'">平空</span>
                    </template>
                </el-table-column>
                <el-table-column label="实现盈亏" align="center" width="100">
                    <template #default="{ row }">
                        <span class="green" v-if="row.pnl1 >= 0">{{ Math.round((row.pnl1) * 100) / 100 }}</span>
                        <span class="red" v-if="row.pnl1 < 0">{{ Math.round((row.pnl1) * 100) / 100 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="盈亏" align="center" width="100">
                    <template #default="{ row }">
                        <span class="green" v-if="row.pnl >= 0">{{ Math.round((row.pnl) * 100) / 100 }}</span>
                        <span class="red" v-if="row.pnl < 0">{{ Math.round((row.pnl) * 100) / 100 }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fee" label="手续费" align="center" width="100">
                    <template #default="{ row }">
                        {{ Math.round((row.fee * 2) * 100) / 100 }}
                    </template>
                </el-table-column>
                <el-table-column prop="volumeInU" label="成交量(U)" align="center" width="100">
                    <template #default="{ row }">
                        {{ Math.round((row.volumeInU) * 100) / 100 }}
                    </template>
                </el-table-column>
                <el-table-column label="成交价" align="center" width="140">
                    <template #default="{ row }">
                        {{ Math.round((row.avgPx) * 10000) / 10000 }}
                    </template>
                </el-table-column>
                <el-table-column prop="openTime" label="开仓时间" align="center" width="180"></el-table-column>
                <el-table-column prop="time" label="平仓时间" align="center" width="180"></el-table-column>
                <el-table-column></el-table-column>
            </el-table>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="warning" size="large" @click="dialogVisible = false">关 闭</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<style scoped>
.page {
    padding: 0 10px !important;
}

.header {
    display: flex;
    margin: 10px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #3a3a3a;
}

.history-body {
    height: calc(100vh - 250px);
    max-height: calc(100vh - 250px);
    overflow-y: auto;
}

.title {
    width: 100px;
    font-size: 20px;
    font-weight: bold;
    color: #3da1d3;
    line-height: 26px;
}

.green {
    color: #67c23a;
}

.red {
    color: #ff707e;
}

.mr15 {
    margin-right: 15px;
}
</style>

<script setup>
import { ref, toRaw, onMounted } from "vue"
import { ElMessage } from 'element-plus'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import * as constants from '@/utils/okxConstants'
import Decimal from 'decimal.js'
import dayjs from 'dayjs'

const systemStore = useSystemStore()
const logStore = useLogStore()
const dialogVisible = ref(false)
const loading = ref(false)
const loadingMore = ref(false)
const list = ref([])
const totalpnl = ref(0)
const totalfee = ref(0)
const total = ref(0)
const page = ref(1)
const fetchData = ref([])

let currentEndTime = null

onMounted(() => {
    load()
})

// 配对开仓和平仓，获得开仓时间
const matchOpenAndClose = (allData) => {
    // 创建一个map来存储平仓对应的开仓时间
    const closeToOpenMap = new Map()

    // 按instId和posSide分组，然后按时间排序
    const grouped = new Map()
    allData.forEach(trade => {
        const key = `${trade.instId}_${trade.posSide}`
        if (!grouped.has(key)) {
            grouped.set(key, [])
        }
        grouped.get(key).push(trade)
    })

    // 对每个组进行FIFO匹配
    for (const [key, trades] of grouped) {
        const sorted = trades.sort((a, b) => Number(a.cTime) - Number(b.cTime))
        const stack = []

        for (const trade of sorted) {
            const isOpen = trade.pnl === "0" || trade.pnl === 0

            if (isOpen) {
                // 开仓：入栈
                stack.push(trade)
            } else {
                // 平仓：出栈并配对
                const closeSz = new Decimal(trade.accFillSz)
                let remaining = closeSz

                while (remaining.gt(0) && stack.length > 0) {
                    const openTrade = stack[0]
                    const openSz = new Decimal(openTrade.accFillSz)

                    if (remaining.gte(openSz)) {
                        // 平仓量>=开仓量，说明开仓被完全平掉
                        remaining = remaining.minus(openSz)
                        stack.shift()

                        // 创建key来标记这对交易
                        const tradeKey = `${openTrade.tradeId}_${trade.tradeId}`
                        closeToOpenMap.set(tradeKey, openTrade)
                    } else {
                        // 平仓量<开仓量，说明只平掉一部分
                        stack[0] = {
                            ...openTrade,
                            accFillSz: openSz.minus(remaining).toString()
                        }
                        remaining = new Decimal(0)

                        const tradeKey = `${openTrade.tradeId}_${trade.tradeId}`
                        closeToOpenMap.set(tradeKey, openTrade)
                    }
                }
            }
        }
    }

    return closeToOpenMap
}

const load = async () => {
    try {
        loading.value = true
        list.value = []
        page.value = 1
        fetchData.value = []

        const params = {
            instType: 'SWAP'
        }

        let result = await systemStore.privateClient.getOrderHistory(params)
        fetchData.value = result

        // 获得开仓和平仓的对应关系
        const closeToOpenMap = matchOpenAndClose(fetchData.value)

        const data = fetchData.value.filter(x => x.pnl !== "0").map(e => {
            e.time = dayjs(parseInt(e.cTime)).format("YYYY-MM-DD HH:mm:ss")
            e.pnl1 = new Decimal(e.pnl).plus(new Decimal(e.fee).times(2))

            // 查找对应的开仓时间
            let openTime = null
            for (const [tradeKey, openTrade] of closeToOpenMap) {
                if (tradeKey.endsWith(`_${e.tradeId}`)) {
                    openTime = dayjs(parseInt(openTrade.cTime)).format("YYYY-MM-DD HH:mm:ss")
                    break
                }
            }
            e.openTime = openTime || '-'

            // 计算成交量U：张数 × 价格 × 合约面值
            let symbol = systemStore.usymbols.find(x => x.symbol === e.instId)

            if (symbol && symbol.info) {
                let ctVal = parseFloat(symbol.info.ctVal) || 1
                e.volumeInU = Math.round(parseFloat(e.accFillSz) * parseFloat(e.avgPx) * ctVal * 100) / 100
            } else {
                e.volumeInU = 0
            }

            return e
        })

        currentEndTime = Date.now()
        list.value.splice(0, list.value.length, ...data)

        //手续费(开仓也要算进去)
        totalfee.value = fetchData.value.reduce((sum, item) => sum + Number(item.fee), 0)
        //盈利(只计算平仓的)
        totalpnl.value = data.reduce((sum, item) => sum + Number(item.pnl), 0)
        //总计
        total.value = totalfee.value + totalpnl.value
        // analyze.value = `${data.filter(x => Number(x.pnl) > 0).length} : ${data.filter(x => Number(x.pnl) < 0).length}`
        loading.value = false
    } catch (error) {
        ElMessage.error(`请求异常： ${error.message}`)
        loading.value = false
        logStore.addLog({
            title: '获取历史委托失败',
            level: 'error',
            message: error
        })
    }
}

const loadMore = async () => {
    try {
        loadingMore.value = true

        const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000
        const end = Number(currentEndTime) - SEVEN_DAYS
        const begin = Number(end - SEVEN_DAYS)

        const params = {
            begin,
            end,
            instType: 'SWAP'
        }

        let result = await systemStore.privateClient.getOrderHistory(params)
        fetchData.value.push(...result)

        // 获得开仓和平仓的对应关系
        const closeToOpenMap = matchOpenAndClose(fetchData.value)

        const data = fetchData.value.filter(x => x.pnl !== "0").map(e => {
            e.time = dayjs(parseInt(e.cTime)).format("YYYY-MM-DD HH:mm:ss")
            e.pnl1 = new Decimal(e.pnl).plus(new Decimal(e.fee).times(2))

            // 查找对应的开仓时间
            let openTime = null
            for (const [tradeKey, openTrade] of closeToOpenMap) {
                if (tradeKey.endsWith(`_${e.tradeId}`)) {
                    openTime = dayjs(parseInt(openTrade.cTime)).format("YYYY-MM-DD HH:mm:ss")
                    break
                }
            }
            e.openTime = openTime || '-'

            // 计算成交量U：张数 × 价格 × 合约面值
            let symbol = systemStore.usymbols.find(x => x.symbol === e.instId)

            if (symbol && symbol.info) {
                let ctVal = parseFloat(symbol.info.ctVal) || 1
                e.volumeInU = Math.round(parseFloat(e.accFillSz) * parseFloat(e.avgPx) * ctVal * 100) / 100
            } else {
                e.volumeInU = 0
            }
            return e
        })

        currentEndTime = end

        list.value.splice(0, list.value.length, ...data)

        //手续费(开仓也要算进去)
        totalfee.value = fetchData.value.reduce((sum, item) => sum + Number(item.fee), 0)
        //盈利(只计算平仓的)
        totalpnl.value = data.reduce((sum, item) => sum + Number(item.pnl), 0)
        //总计
        total.value = totalfee.value + totalpnl.value

        loadingMore.value = false
        page.value++
    } catch (error) {
        ElMessage.error(`请求异常： ${error.message}`)
        loadingMore.value = false
        logStore.addLog({
            title: '获取历史委托失败',
            level: 'error',
            message: error
        })
    }
}

const showDialog = () => {
    dialogVisible.value = true
}

defineExpose({ showDialog })
</script>